import { Button, CircularProgress, Modal, TextField } from "@material-ui/core";
import { RequestStatus } from "components/GeneralFormView/types";
import { WheelEventsGroup } from "mobx-store/storeInterfaces/wheelFortuneInterface";
import React, { useEffect, useState } from "react";
import { AddEditEventsGroupsProps } from "../types";
import styles from './styles.module.scss';
const AddEditEventModal: React.FC<AddEditEventsGroupsProps>= (props: AddEditEventsGroupsProps) => {
    const {
        open,
        wheelEventsGroup,
        onClose,
        onSaveForm,
        loadingState
    } = props;
    const [ formValue, setFormValue ] = useState<WheelEventsGroup>({
        id: wheelEventsGroup?.id || -1,
        eventGroupTitle: wheelEventsGroup?.eventGroupTitle || ''
    });
    useEffect (() => {
        setFormValue({
            id: wheelEventsGroup?.id || -1,
            eventGroupTitle: wheelEventsGroup?.eventGroupTitle || ''
        });
    }, [wheelEventsGroup])
    const TitleField = () => {
        return (
            <TextField 
                value={formValue.eventGroupTitle}
                variant="outlined"
                placeholder="Please enter group title"
                onChange={(e) => setFormValue(prev => ({
                    id: prev.id,
                    eventGroupTitle: e.target.value
                }))}
                autoFocus
            />
        );
    };
    const ActionButton = (props: { loading: boolean }) => {
        const { loading } = props;
        if(loading) {
            return (<CircularProgress />);
        }
        return (
            <Button 
                variant="contained"
                color="primary"
                onClick={() => onSaveForm(formValue)}
                >
                    {wheelEventsGroup?.id ? 'Save' : 'Add'}
            </Button>
        )
    }
    const ErrorMessage = (props: {error: boolean}) => {
        const { error } = props;
        if(error) {
            return (<div className={styles.error}>Please enter valid form</div>)
        }
        return (<> </>);
    };
    return (
        <Modal
            open={open}
            onClose={onClose}
        >
        <div className={styles.modalBody}>
            <TitleField />
            <ActionButton loading={loadingState === RequestStatus.LOADING} />
            <ErrorMessage error={loadingState === RequestStatus.FAILED} />
        </div>
      </Modal>
    );
}
export default AddEditEventModal;